import React from 'react';
import { Box } from '@mui/material';
import ComponentsByVehicleDashboard from '../../components/maintenance/component/ComponentsByVehicleDashboard';

const ComponentesVehiculoPage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <ComponentsByVehicleDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de componentes por vehiculo:', newOrder);
        }}
      />
    </Box>
  );
};

export default ComponentesVehiculoPage;